import type { AgreementsComparePayload, AgreementsCompareResponse } from '@/types/Models/Agreements'
import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class AgreementsProxy extends BaseProxy implements ProxyMethods<AgreementsCompareResponse> {
  public endpoint = 'agreements'

  compare(payload: AgreementsComparePayload) {
    return this.submit<AgreementsCompareResponse>('post', `/${this.endpoint}/compare`, payload)
  }
}
